import { useQuery } from "react-query";
import moment from "moment";
import { getProfitLossReport } from "../../../../../api/accountReports";
import {
  FiltersInterface,
  ProfitLossInterface
} from "../../../../../interfaces/AccountReportsInterface";
import { queryKeys } from "../../../../../react-query/constants";

export default function useBalanceSheet(filters: FiltersInterface): ProfitLossInterface[] {
  const { periodDate, showPreviousYearPeriod } = filters;

  const previousYear = showPreviousYearPeriod
    ? moment(periodDate).subtract(1, "year").toISOString()
    : "";
  const queryParams = `date=${periodDate.toISOString()}&previousYearDate=${previousYear}`;

  const { data = [] } = useQuery(
    [queryKeys.account, "profitLossReport", { periodDate, showPreviousYearPeriod }],
    () => getProfitLossReport(queryParams),
    {
      refetchOnMount: true
    }
  );
  return data;
}
